(($, Drupal, drupalSettings) => {
  Drupal.behaviors.officeAddons = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('.field--name-field-customer-stories')).once('customer_stories').each( (index, item) => {
      $(once('customer_stories', '.field--name-field-customer-stories')).each( (index, item) => {
        //item.style.width = '100%';
        $(item).owlCarousel({
          loop:true,
          items:1,
          nav:true,
          autoplay: true,
          autoplayTimeout: 10000,
        });
      });
      // $(context.querySelectorAll('.block-views-blockprofessionals-professional-listing .views-exposed-form')).once('selectbinding').each( (index, item) => {
      $(once('selectbinding', '.block-views-blockprofessionals-professional-listing .views-exposed-form')).each( (index, item) => {
        var sendButton = item.querySelector('input[type=submit]');
        sendButton.style.display = 'none';
        var selectList = item.querySelector('select');
        selectList.addEventListener('change', e => {
          $(sendButton).click();
        })
      });
    }
  }
})(jQuery, Drupal, drupalSettings);
